export default __webpack_public_path__ + "f1647909517e1db6ec72109979b79919.svg";